module.exports = __webpack_public_path__ + "static/zqb3pro.9f974f68.png";